export default __webpack_public_path__ + "8b8d1ee68ce3e4e7f86f0e9ad38e3fb3.svg";